import React, { useState } from "react";
import { Form, Input, Modal } from "antd";
import axios from "axios";
import { getUserEmail } from "../../../services/utils";
import { useOpenNotification } from "../../../components/Notification/notification";

interface SupplierOrgDialogProps {
  onComplete: () => void;
}

const SupplierOrgDialog: React.FC<SupplierOrgDialogProps> = ({ onComplete }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState<boolean>(false);
  const { openNotification, contextHolder } = useOpenNotification();

  const handleSubmit = () => {
    form
      .validateFields()
      .then(({ supplierOrg }) => {
      setSubmitting(true);

      axios
        .post(
          `${process.env.REACT_APP_PROXY_URL}/v1/updateSupplierOrg`,
          { emailId: getUserEmail(), supplierOrg },
          {
            headers: {
              Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
              "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
            },
          }
        )
        .then((response) => {
          const errorMessage = response?.data?.errorMessage;
          if (errorMessage) {
            openNotification("error", errorMessage);
            return;
          }

          const profileRaw = sessionStorage.getItem("profile");
          if (profileRaw) {
            const profile = JSON.parse(profileRaw);
            profile.organisation = supplierOrg;
            sessionStorage.setItem("profile", JSON.stringify(profile));
          }

          openNotification("success", "Supplier organization saved successfully");
          setTimeout(() => {
            onComplete();
            setSubmitting(false);
          }, 600);
        })
        .catch((error: any) => {
          const msg =
            error?.response?.data?.errorMessage ||
            error?.response?.data?.error ||
            error?.message ||
            "Failed to save supplier organization. Please try again.";
          openNotification("error", msg);
        });
      })
      .catch(() => {
        // Ant Design shows field errors automatically — nothing to do here
      });
  };

  return (
    <>
      {contextHolder}
      <Modal
      title="Finish Setting Up Your Account"
      open
      onOk={handleSubmit}
      okText="Save"
      okButtonProps={{ loading: submitting }}
      closable={false}
      maskClosable={false}
      keyboard={false}
      cancelButtonProps={{ style: { display: "none" } }}
      width={580}
      centered
      styles={{
        mask: { backdropFilter: "blur(2px)", background: "rgba(0,0,0,0.35)" },
        content: { borderRadius: 12, padding: "32px 40px" },
        header: { marginBottom: 0 },
      }}
    >
      <div style={{ marginTop: 0, marginBottom: 12 }}>
        Please specify your organization to complete your account setup.
      </div>
      <Form form={form} layout="vertical">
        <Form.Item
          label="Supplier Organization"
          name="supplierOrg"
          rules={[{ required: true, message: "This is a required field" }]}
        >
          <Input
            placeholder="Enter your supplier organization"
            size="large"
          />
        </Form.Item>
      </Form>
    </Modal>
    </>
  );
};

export default SupplierOrgDialog;
